import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { ValidatedTokenService } from '@app/shared/services/validated-token/validated-token.service';
import { debounceTime } from 'rxjs/operators';
var OccurenceDescriptionComponent = /** @class */ (function () {
    function OccurenceDescriptionComponent(validatedTokenService) {
        this.validatedTokenService = validatedTokenService;
    }
    OccurenceDescriptionComponent.prototype.ngOnInit = function () {
        this.autosize.minRows = 5;
        this.validatedComments();
    };
    OccurenceDescriptionComponent.prototype.validatedComments = function () {
        var _this = this;
        var comments = this.occurrenceForm.get('description');
        comments.valueChanges
            .pipe(debounceTime(100))
            .subscribe(function (description) { return comments.setValue(_this.validatedTokenService.DOMParser(description)); });
    };
    return OccurenceDescriptionComponent;
}());
export { OccurenceDescriptionComponent };
